import { Cell, Column, Heading, TimePeriodValue } from "@edgetier/client-components";
import { differenceInSeconds } from "date-fns";
import { FunctionComponent, memo } from "react";
import { IAgent } from "@edgetier/watchtower-types";
import { IProps } from "./live-agents-table-state-duration-column.types";
import "./live-agents-table-state-duration-column.scss";

/**
 * Display for how long an agent has been in the current state.
 * @returns Sortable agent state duration column.
 */
const LiveAgentsTableStateDurationColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading sortProperty="agentStateUpdateDateTime" reverseSortDirection>
                Time In State
            </Heading>
            <Cell<Pick<IAgent, "agentStateUpdateDateTime">>>
                {({ agentStateUpdateDateTime }) => (
                    <TimePeriodValue
                        seconds={
                            agentStateUpdateDateTime instanceof Date
                                ? differenceInSeconds(new Date(), agentStateUpdateDateTime)
                                : null
                        }
                    />
                )}
            </Cell>
        </Column>
    );
};

export default memo(LiveAgentsTableStateDurationColumn);
